import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { usePaymentConfig } from '../../config/PaymentConfigProvider';

interface Props {
  children: React.ReactNode;
}

export const I18nProvider = ({ children }: Props) => {
  const { language } = usePaymentConfig();

  if (i18n.language !== language) {
    i18n.changeLanguage(language);
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export function withI18nProvider<P extends object>(Component: React.FunctionComponent<P>): React.FunctionComponent<P> {
  return (props: P) => (
    <I18nProvider>
      <Component {...props} />
    </I18nProvider>
  );
}
